import { environment } from '../env'

export const API_ROOT_URL = environment.API_ROOT_URL
export const SERVICE_ROOT_URL = environment.SERVICE_URL
export const WS_ROOT_URL = environment.WS_ROOT_URL
